import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      label: this.el.querySelector('label'),
      input:
        this.el.querySelector('input:not([type="hidden"])') ||
        this.el.querySelector('textarea')
    };

    this.checkInputValue();
  }

  addListeners() {
    this.dom.input.addEventListener('change', this.checkInputValue.bind(this));
    this.dom.input.addEventListener('keyup', this.checkInputValue.bind(this));
  }

  checkInputValue() {
    if (this.dom.input.value) {
      this.dom.input.classList.add('is-filled');
    } else {
      this.dom.input.classList.remove('is-filled');
    }
  }
}

export default Module;
